module.exports = __webpack_public_path__ + "static/media/logoinpi_en.d92d0cbc.svg";